"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAlertChangeRefresh = void 0;
const react_1 = require("react");
const subscriptions_1 = require("../../graphql/subscriptions");
const amplifyBootstrap_1 = require("../../utils/amplifyBootstrap");
/**
 * Calls `refetch` whenever a sensor alert is created or its acknowledged
 * state changes. Aggregation hooks rely on a 30s polling interval; without
 * this, dashboards show a stale "1 leak" / "1 alert" for up to half a minute
 * after the user clears it. Subscription handlers fire within a second of
 * the resolver writing, so the UI updates feel instant.
 *
 * Both subscriptions are unfiltered/global. Callers should pass a `refetch`
 * that only re-fetches data they care about (the hook's own sensors) — the
 * extra invocations for unrelated hubs are cheap and debounced naturally by
 * React batching.
 */
function useAlertChangeRefresh(refetch) {
    (0, react_1.useEffect)(() => {
        let createSub;
        let ackSub;
        try {
            createSub = amplifyBootstrap_1.API.graphql({ query: subscriptions_1.onCreateSensorAlert }).subscribe({
                next: () => refetch(),
                error: (err) => console.error('[useAlertChangeRefresh] create subscription error:', err),
            });
            ackSub = amplifyBootstrap_1.API.graphql({ query: subscriptions_1.onSensorAlertAcknowledgedStateUpdated }).subscribe({
                next: () => refetch(),
                error: (err) => console.error('[useAlertChangeRefresh] ack subscription error:', err),
            });
        }
        catch (err) {
            console.error('[useAlertChangeRefresh] failed to set up subscriptions:', err);
        }
        return () => {
            try {
                createSub?.unsubscribe?.();
            }
            catch {
                /* ignore */
            }
            try {
                ackSub?.unsubscribe?.();
            }
            catch {
                /* ignore */
            }
        };
    }, [refetch]);
}
exports.useAlertChangeRefresh = useAlertChangeRefresh;
